"use client";

/**
 * Root-layout error boundary. Renders when the root layout itself throws,
 * replacing the default blank/unstyled Next.js crash screen.
 *
 * Must define its own <html>/<body> and must not rely on global CSS,
 * fonts, or any app providers — everything is inline and self-contained.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en-GB">
      <body
        style={{
          margin: 0,
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#F7F9F6",
          color: "#171817",
          fontFamily:
            "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
          padding: "24px",
        }}
      >
        <main style={{ maxWidth: 420, textAlign: "center" }}>
          <p
            style={{
              fontSize: 12,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#5c5c56",
              margin: "0 0 12px",
            }}
          >
            HubSEO
          </p>
          <h1 style={{ fontSize: 26, lineHeight: 1.25, margin: "0 0 12px", fontWeight: 600 }}>
            Something went wrong on our side
          </h1>
          <p style={{ fontSize: 15, lineHeight: 1.6, color: "#5c5c56", margin: "0 0 24px" }}>
            The page failed to load. Your data is safe · this is a temporary
            fault, not a problem with your account.
            {error?.digest ? (
              <>
                {" "}
                Reference code: <code style={{ fontSize: 13 }}>{error.digest}</code>
              </>
            ) : null}
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                background: "#171817",
                color: "#F7F9F6",
                border: "none",
                borderRadius: 10,
                padding: "12px 22px",
                fontSize: 15,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Try again
            </button>
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global error boundary: router context may be broken, Link unsafe */}
            <a
              href="/"
              style={{
                display: "inline-block",
                background: "transparent",
                color: "#171817",
                border: "1px solid #d8d8d2",
                borderRadius: 10,
                padding: "12px 22px",
                fontSize: 15,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              Back to homepage
            </a>
          </div>
        </main>
      </body>
    </html>
  );
}
